<template>
<section>

	<div class="result-wrap nocount text-center">
		<div class="result-thumb">
			<img src="../assets/img/zhushe.png">
		</div>
		<div class="result-text">餐前需注射胰岛素</div>
		<div class="result-time wcar">
			<div class="times" v-if="unit"><span>{{unit}}</span>单位</div>
		</div>
	</div>

	<div class="calculate-link" @click="gohome()">返回首页</div>

</section>
</template>

<script>
  export default {
    data () {
      return {
        unit:''
      }
    },
    head: {
    title: function () {
      return {
        inner: '餐前注射胰岛素',
        separator: ' ', 
            complement: ' '
      }
    }
  },
    created(){
    	this.unit = this.$route.query.unit
    },
    methods:{
    	gohome(){
        this.$router.replace({ path: '/carboindex'});
      }
    }
  }
</script>


// WEBPACK FOOTER //
// carbofinal.vue?085cb03e